export const state = {
    organizationSettings: []
};
